import type { ReactNode } from 'react';
import { usePortal } from '../../../hooks/usePortal';
import { Flex } from '../../Core';
import { ToolbarButtonWrapper, ToolbarWrapper } from './styles';

export const MOBILE_HEADER_TOOLBAR_PORTAL = 'mobile-header-toolbar-portal';
export const MOBILE_HEADER_TITLE_PORTAL = 'mobile-header-title-portal';

interface MobileHeaderProps {
  toolbarContent?: ReactNode;
}

export function MobileHeader({ toolbarContent }: MobileHeaderProps) {
  const { setPortalRef: setToolbarPortalRef } = usePortal(MOBILE_HEADER_TOOLBAR_PORTAL);
  const { setPortalRef: setTitlePortalRef } = usePortal(MOBILE_HEADER_TITLE_PORTAL);

  return (
    <ToolbarWrapper>
      <Flex alignItems="center" minWidth={0} ref={setTitlePortalRef} />
      <Flex gap="spacing10" flexShrink={0}>
        <ToolbarButtonWrapper ref={setToolbarPortalRef} />
        {toolbarContent != null ? <ToolbarButtonWrapper>{toolbarContent}</ToolbarButtonWrapper> : null}
      </Flex>
    </ToolbarWrapper>
  );
}
